import { Form, Input, Button, message } from 'antd';
import { login } from '../api/api';
import '../styles/Login.css';

const Login = ({ setAuthenticated }) => {
    const onFinish = async (values) => {
        try {
            const phone = values.phone.substring(1);
            const response = await login(phone, values.password);

            if (response.data?.success) {
                const accessToken = response.data?.data?.access_token;
                localStorage.setItem('accessToken', accessToken);
                setAuthenticated(true);
                window.location.reload();
                message.success('Tizimga muvaffaqiyatli kirildi!');
            } else {
                message.error('Login yoki parol xato!');
                alert('Login yoki parol xato!');
            }
        } catch (error) {
            console.error('Login failed:', error);
            message.error('Xato yuz berdi, iltimos qayta urinib ko‘ring!');
        }
    };

    return (
        <div className="login-container">
            <Form className="login-form" onFinish={onFinish}>
                <h2 className="login-title">Tizimga kirish</h2>

                <Form.Item
                    name="phone"
                    rules={[
                        { required: true, message: 'Telefon raqamni kiriting!' },
                        {
                            pattern: /^\+998\d{9}$/,
                            message: 'Telefon raqam +998 va 9 ta raqam bilan bo‘lishi kerak!',
                        },
                    ]}
                >
                    <Input
                        placeholder="+998901234567"
                        maxLength={13}
                        defaultValue="+998"
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!value.startsWith('+998')) {
                                e.target.value = '+998';
                            }
                        }}
                    />
                </Form.Item>

                <Form.Item
                    name="password"
                    rules={[{ required: true, message: 'Parolni kiriting!' }]}
                >
                    <Input.Password placeholder="Parol" />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" className="login-form-button">
                        Kirish
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default Login;
